// Global Imports
import ReactDOM from "react-dom";
import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

// Global Styles
import './styles/main.scss';

// Partials
import Header from "./partials/header";
import Footer from "./partials/footer";

// Routes
const Home = lazy(() => import('./controllers/home'));
const About = lazy(() => import('./controllers/about'));
const Clients = lazy(() => import('./controllers/clients'));
const Services = lazy(() => import('./controllers/services'));
const Projects = lazy(() => import('./controllers/projects'));
const Contact = lazy(() => import('./controllers/contact'));
const Error = lazy(() => import('./controllers/404'));

// Create App
const App = () => (
    <Router>
        <Header />
        <Suspense fallback={<div>Loading...</div>}>
            <main>
                <Switch>
                    <Route exact path="/" component={Home}/>
                    <Route path="/about" component={About}/>
                    <Route path="/clients" component={Clients}/>
                    <Route path="/projects" component={Projects}/>
                    <Route path="/projects/*" component={Projects}/>
                    <Route path="/services" component={Services}/>
                    <Route path="/contact" component={Contact}/>
                    <Route path="/*" component={Error}/>
                </Switch>
            </main>
        </Suspense>
        <Footer />
    </Router>
);

// Render App
ReactDOM.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
    document.querySelector('.container')
);